// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1c_Bg","left":"InfoRow_left__2MLq1"};